import axios from 'axios'

import cookies from 'services/cookies'

const LMS_API = process.env.LMS_API

export async function fetchIsRegisteredForOnRamp() {
  const token = cookies.getAccessToken()

  if (!token || !LMS_API) {
    return
  }

  const { data } = await axios.get(`${LMS_API}?expand=registration`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return (
    data.registration && data.registration.registration_status === 'confirmed'
  )
}
